export default "__VITE_ASSET__95695b18__"